import React, { useState, useEffect, useRef } from "react";
import { useProviderStore } from "../../store/providerStore";


const ScrollSpy: React.FC = () => {
  const { sections } = useProviderStore();
  const containerRef = useRef<HTMLDivElement | null>(null); // this works by using the useRef hook to get the reference of the container div, so that we can add or remove the shadow class when the user scrolls
  const [activeSection, setActiveSection] = useState<number>(sections[0]?.tagId);

  useEffect(() => {
    if (sections.length > 0) {
      setActiveSection(sections[0].tagId);
    }
    // used to highlight the section in the navbar when scrolled to that section
    const handleScroll = () => {
      let currentSection = activeSection;
      sections.forEach((section) => {
        // for each section, check if the window is scrolled to that section
        const element = document.getElementById(`${section.tagId}`);
        if (element) {
          const offsetTop = element.offsetTop; // get the offsetTop of the section
          if (window.pageYOffset >= offsetTop - window.innerHeight / 3) {
            // if the window is scrolled to the section
            currentSection = section.tagId; // if the window is scrolled to the section, set the current section to that section
          }
        }
      });
      setActiveSection(currentSection);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll); // prevents memory leak by removing the event listener when the component is unmounted
    };
  }, [sections]);

  useEffect(() => {
    // used to add or remove the shadow class when the user scrolls down
    const toggleShadowClass = () => {
      if (window.scrollY > 100) {
        containerRef.current?.classList.add("navbar-shadow");
      } else {
        containerRef.current?.classList.remove("navbar-shadow");
      }
    };
    document.addEventListener("scroll", () => toggleShadowClass());
    return () => document.removeEventListener("scroll", toggleShadowClass);
  }, []);

  return (
    <nav className="sticky-to">
      <div className="d-flex testScrollSpy scrollbar">
        {sections.map((section, index) => (
          <div
            key={`${section.tagId}-${index}`}
            style={{
              whiteSpace: "nowrap",
              fontWeight: activeSection === section.tagId ? "400" : "normal",
              cursor: "pointer",
              padding: "10px",
              paddingLeft: "40px",
              textDecoration:
                activeSection === section.tagId ? "underline" : "none",
              textDecorationThickness:
                activeSection === section.tagId ? "3px" : "initial", // Adjust thickness when selected
              textDecorationColor:
                activeSection === section.tagId ? "black" : "initial", // Adjust color when selected
              textUnderlineOffset:
                activeSection === section.tagId ? "15px" : "initial", // Add space between text and underline
            }}
          >
            <a
              style={{
                fontSize: "25px",
                color: activeSection === section.tagId ? "black" : "gray",
              }}
              href={`#${section.tagId}`}
      //        onClick={() => setActiveSection(section.tagId)}
            >
              {section.name}
            </a>
          </div>
        ))}
      </div>
    </nav>
  );
};

export default ScrollSpy;
// **small bug where if you scroll all the way down before opening the scrollspy, and then open it, the selected default section will be the last one. fix later**
